(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["header"]) return;
  try {
    
  class StickyHeader extends HTMLElement {
    constructor() {
      super();
    }

    connectedCallback() {
      this.header = document.querySelector('.section-header');
      this.headerIsAlwaysSticky = this.getAttribute('data-sticky-type') === 'always' || this.getAttribute('data-sticky-type') === 'reduce-logo-size';
      this.headerBounds = {};
      this.currentScrollTop = 0;
      this.preventReveal = false;
      this.predictiveSearch = this.querySelector('predictive-search');
      this.isTransparent = document.querySelector('.header-wrapper').classList.contains('transparent-header');

      this.setHeaderHeight();

      window.matchMedia('(max-width: 990px)').addEventListener('change', this.setHeaderHeight.bind(this));

      if (this.headerIsAlwaysSticky) {
        this.header.classList.add('shopify-section-header-sticky');
      };

      this.onScrollHandler = this.onScroll.bind(this);
      this.hideHeaderOnScrollUp = () => this.preventReveal = true;

      this.addEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.addEventListener('scroll', this.onScrollHandler, false);

      this.createObserver();
    }

    setHeaderHeight() {
      document.documentElement.style.setProperty('--header-height', `${this.header.offsetHeight}px`);
    }

    disconnectedCallback() {
      this.removeEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.removeEventListener('scroll', this.onScrollHandler);
    }

    createObserver() {
      let observer = new IntersectionObserver((entries, observer) => {
        this.headerBounds = entries[0].intersectionRect;
        observer.disconnect();
      });

      observer.observe(this.header);
    }

    onScroll() {
      const scrollTop = window.pageYOffset || document.documentElement.scrollTop;

      if (this.predictiveSearch && this.predictiveSearch.isOpen) return;

      if (this.isTransparent) {
        if (scrollTop > this.headerBounds.bottom) {
          this.header.classList.add('scrolled-past-header');
          this.header.classList.remove('transparent-header');
          if (scrollTop > this.currentScrollTop) {
            this.header.classList.add('shopify-section-header-hidden');
          } else {
            this.header.classList.remove('shopify-section-header-hidden');
          }
        } else {
          this.header.classList.remove('scrolled-past-header', 'shopify-section-header-hidden');
          this.header.classList.add('transparent-header');
        }
        this.currentScrollTop = scrollTop;
        return;
      }

      if (scrollTop > this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (this.preventHide) return;
        requestAnimationFrame(this.hide.bind(this));
      } else if (scrollTop < this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (!this.preventReveal) {
          requestAnimationFrame(this.reveal.bind(this));
        } else {
          window.clearTimeout(this.isScrolling);

          this.isScrolling = setTimeout(() => {
            this.preventReveal = false;
          }, 66);

          requestAnimationFrame(this.hide.bind(this));
        }
      } else if (scrollTop <= this.headerBounds.top) {
        this.header.classList.remove('scrolled-past-header');
        requestAnimationFrame(this.reset.bind(this));
      }

      this.currentScrollTop = scrollTop;
    }

    hide() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-hidden', 'shopify-section-header-sticky');
      this.closeMenuDisclosure();
      this.closeSearchModal();
    }

    reveal() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-sticky', 'animate');
      this.header.classList.remove('shopify-section-header-hidden');
    }

    reset() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.remove('shopify-section-header-hidden', 'shopify-section-header-sticky', 'animate');
    }

    closeMenuDisclosure() {
      this.disclosures = this.disclosures || this.header.querySelectorAll('header-menu');
      this.disclosures.forEach(disclosure => disclosure.close()); 
    }

    closeSearchModal() {
      this.searchModal = this.searchModal || this.header.querySelector('details-modal');
      this.searchModal.close(false);
    }
  }

  customElements.define('sticky-header', StickyHeader);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["lookbook"] && !Shopify.designMode) return;
  try {
     
  class luminLookBook extends HTMLElement {
    constructor () {
      super()

      this.injectVendorScripts()
      this.querySelectorAll('.lumin-lookbook-point-list-item').forEach((elem) => {
        this.handleTooltip(elem)
      })
    } 
    
    async injectVendorScripts () {
      if (!window.FloatingUICore) {
        const script = document.createElement('script')
        script.setAttribute('src', 'https://cdn.jsdelivr.net/npm/@floating-ui/core@1.6.0')
        document.head.appendChild(script) 
      }
      if (!window.FloatingUIDOM) {
        await new Promise(r => setTimeout(r, 500))

        const script = document.createElement('script')
        script.setAttribute('src', 'https://cdn.jsdelivr.net/npm/@floating-ui/dom@1.6.1')
        document.head.appendChild(script)
      }
    }

    handleTooltip(elem) {
      const btn = elem.querySelector('button')
      const tooltip = elem.querySelector('.lumin-tooltip')

      function update() {
        window.FloatingUIDOM.computePosition(btn, tooltip, {
          middleware: [
            window.FloatingUIDOM.offset(0),
            window.FloatingUIDOM.autoPlacement()
          ],
        }).then(({x, y}) => {
          Object.assign(tooltip.style, {
            left: `${x}px`,
            top: `${y}px`,
          })
        })
      }

      function showTooltip() {
        tooltip.classList.add('show')
        update()
      }
      
      function hideTooltip() {
        setTimeout(() => {
          tooltip.classList.remove('show')
          tooltip.classList.add('hiding')
          setTimeout(() => {
            tooltip.classList.remove('hiding')
          }, 200)
        }, 100)
      }
      
      if (window.matchMedia("(pointer: coarse)").matches) {
        [
          ['mouseenter', showTooltip],
          ['mouseleave', hideTooltip],
          ['focus', showTooltip],
          ['blur', hideTooltip],
        ].forEach(([event, listener]) => {
          btn.addEventListener(event, listener)
        })
      } else {
        [
          ['focus', showTooltip],
          ['blur', hideTooltip],
        ].forEach(([event, listener]) => {
          btn.addEventListener(event, listener)
        })
      }
    }
  }
  customElements.define('lumin-lookbook', luminLookBook)

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["video-gallery"] && !Shopify.designMode) return;
  try {
    

class VideoGallery extends HTMLElement {
  constructor() {
    super();
    this.deferredMedia = this.querySelector(".video-gallery__media");
    this.videoPlaylist = this.querySelector(".video-gallery__thumbnails");
    this.activeVideoTitle = this.querySelector(".video-gallery__active-video-title");
    this.videoPlayer = null;

    this.handleVideoClick = this.handleVideoClick.bind(this);
  }

  connectedCallback() {
    this.videoPlaylist.addEventListener("click", this.handleVideoClick);
  }

  disconnectedCallback() {
    this.videoPlaylist.removeEventListener("click", this.handleVideoClick);
  }

  getVideoEmbedRef = () => {
    return document.querySelector('.video-gallery__embed');
  }

  getVideoPlayerRef = () => {
    return document.querySelector('.video-gallery__player');
  }

  clearExistingMedia = (type) => {
    
    const existingEmbed = this.getVideoEmbedRef();
    const existingPlayer = this.getVideoPlayerRef();

    if (type === 'video' && existingEmbed) {
      existingEmbed.remove();
    }

    if (type === 'embed' && existingPlayer) {
      existingPlayer.remove();
    }
  }

  handleVideoClick = (e) => {

    const thumbnailElement = event.target.closest(".video-gallery__thumbnail");
    if (!thumbnailElement) {
      console.error('Thumbnail element not found');
      return;
    }
    
    if (this.deferredMedia) {
      this.deferredMedia.loadContent(false);
    }

    const videoURL = thumbnailElement.dataset.videoUrl;
    const embedType = thumbnailElement.dataset.embedUrlType;
    const embedID = thumbnailElement.dataset.embedUrlId;
    const videoTitle = thumbnailElement.dataset.videoTitle;
    
    if (videoURL) {
        // Load video
        this.loadVideo(videoURL, videoTitle);
    } else if (embedType && embedID) {
        // Load embed
        this.loadEmbed(embedType, embedID, videoTitle);
    } else {
        console.error('Video URL or embed URL not found');
    }

    this.scrollToVideoPlayer(); 
  }

  // Function to scroll to the video player
  scrollToVideoPlayer = () => {
    if (!this.videoPlayer) {
      console.error('Video player element not found');
      return;
    }

    const videoPlayerPosition = this.videoPlayer.getBoundingClientRect().top + window.scrollY - 150;

    window.scrollTo({
      top: videoPlayerPosition,
      behavior: 'smooth'
    });
  }

  loadVideo = (videoURL, videoTitle) => {

    this.clearExistingMedia('video');

    // Get the video player
    this.videoPlayer = this.getVideoPlayerRef();

    if (!this.videoPlayer) {
      console.log('Video player element not found, creating it');
      this.videoPlayer = document.createElement('video');
      this.videoPlayer.classList.add('video-gallery__player');
      this.videoPlayer.setAttribute('playsinline', '');
      this.videoPlayer.setAttribute('autoplay', '');
      this.videoPlayer.setAttribute('controls', '');

      this.deferredMedia.appendChild(this.videoPlayer);
    }
    
    // Set video source and title
    this.videoPlayer.src = videoURL;
    this.videoPlayer.load();

    // Play the video
    this.videoPlayer.addEventListener('loadedmetadata', function loadedMetadataHandler() {
      this.videoPlayer.play()
        .then(() => {
          console.log('Video started playing');
          // Remove the event listener after playback starts
          this.videoPlayer.removeEventListener('loadedmetadata', loadedMetadataHandler);
        })
        .catch((error) => {
          console.error('Error playing video:', error);
        });
    }.bind(this));

    // Update the active video title
    this.activeVideoTitle.innerText = videoTitle;
  }

  loadEmbed = (embedType, embedID, videoTitle) => {

    if (embedType !== 'youtube' && embedType !== 'vimeo') {
      console.error('Invalid embed type');
      return;
    }

    this.clearExistingMedia('embed');

    const embedURL = (embedType == 'youtube') ? `https://www.youtube.com/embed/${embedID}?autoplay=1`: `https://player.vimeo.com/video/${videoId}?autoplay=1`;

    let embedElement = this.getVideoEmbedRef();

    if (!embedElement) {
      embedElement = document.createElement('iframe');
      embedElement.classList.add('video-gallery__embed');
      embedElement.setAttribute('allow', 'autoplay; encrypted-media');
      embedElement.setAttribute('allowfullscreen', '');
      this.deferredMedia.appendChild(embedElement);
    }
    
    embedElement.src = embedURL;
    embedElement.setAttribute('title', videoTitle);

    this.videoPlayer = embedElement;

    this.activeVideoTitle.innerText = videoTitle;
  }

}

customElements.define('video-gallery', VideoGallery);


  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["yrvia-gallery-hero"] && !Shopify.designMode) return;
  try {
    
if (!customElements.get('yrvia-film')) {
  customElements.define('yrvia-film', class extends HTMLElement {
    connectedCallback() {
      this.abort?.abort();
      this.observer?.disconnect();
      this.abort = new AbortController();
      const options = {signal: this.abort.signal};
      const video = this.querySelector('video');
      const button = this.querySelector('.yv-film-control');
      const sound = this.querySelector('.yv-film-sound');
      if (!video || !button || !sound) return;
      const size = matchMedia('(max-width: 749px)');
      const reduced = matchMedia('(prefers-reduced-motion: reduce)');
      let userPaused = false;
      let inView = true;
      let pending = false;
      const sync = () => {
        button.setAttribute('aria-label', video.paused ? button.dataset.play : button.dataset.pause);
        button.dataset.playing = String(!video.paused);
        const label = video.muted ? sound.dataset.unmute : sound.dataset.mute;
        sound.setAttribute('aria-label', label);
        sound.setAttribute('aria-pressed', String(!video.muted));
        sound.querySelector('span').textContent = label;
      };
      const play = (manual = false) => {
        if (pending || !this.isConnected || document.hidden ||
          (!manual && (userPaused || reduced.matches || !inView))) return;
        pending = true;
        const result = video.play();
        Promise.resolve(result).catch(() => {}).finally(() => {
          pending = false;
          if (!this.isConnected) video.pause();
          sync();
        });
      };
      const resume = () => { if (video.paused) play(); };
      const select = () => {
        const src = (size.matches ? this.dataset.mobile : this.dataset.desktop) || this.dataset.desktop || this.dataset.mobile;
        if (!src) return;
        video.poster = size.matches ? this.dataset.mobilePoster : this.dataset.desktopPoster;
        if (video.getAttribute('src') === src) { resume(); return; }
        video.pause();
        video.autoplay = !reduced.matches && !userPaused;
        video.src = src;
        video.load();
        resume();
      };
      video.defaultMuted = true;
      video.muted = true;
      video.setAttribute('muted', '');
      video.playsInline = true;
      video.setAttribute('playsinline', '');
      video.setAttribute('webkit-playsinline', '');
      video.loop = true;
      video.controls = false;
      video.autoplay = !reduced.matches;
      if (reduced.matches) video.pause();
      button.hidden = false;
      sound.hidden = false;
      button.addEventListener('click', () => {
        if (video.paused) { userPaused = false; play(true); }
        else { userPaused = true; video.autoplay = false; video.pause(); }
      }, options);
      sound.addEventListener('click', () => {
        video.muted = !video.muted;
        if (video.paused) { userPaused = false; play(true); }
        sync();
      }, options);
      ['loadeddata', 'canplay'].forEach(event => video.addEventListener(event, resume, options));
      ['playing', 'pause', 'volumechange'].forEach(event => video.addEventListener(event, sync, options));
      video.addEventListener('error', () => { video.controls = true; button.hidden = true; }, options);
      size.addEventListener('change', select, options);
      reduced.addEventListener('change', () => {
        video.autoplay = !reduced.matches && !userPaused;
        if (reduced.matches) video.pause();
        else resume();
      }, options);
      document.addEventListener('visibilitychange', () => {
        if (document.hidden) video.pause();
        else resume();
      }, options);
      window.addEventListener('pageshow', resume, options);
      if ('IntersectionObserver' in window) {
        this.observer = new IntersectionObserver(entries => {
          inView = entries[0].isIntersecting;
          if (inView) resume();
          else video.pause();
        }, {threshold: 0.05});
        this.observer.observe(video);
      }
      select();
      sync();
    }
    disconnectedCallback() {
      this.abort?.abort();
      this.observer?.disconnect();
      this.querySelector('video')?.pause();
    }
  });
}

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["yrvia-header"]) return;
  try {
    
function yrviaHeaderInit() {
  if (typeof subscribe === 'function' && typeof PUB_SUB_EVENTS !== 'undefined') {
    subscribe(PUB_SUB_EVENTS.cartUpdate, function(event) {
      if (event.cartData && typeof event.cartData.item_count === 'number') {
        document.querySelectorAll('.yv-bag span').forEach(function(badge) { badge.textContent = event.cartData.item_count; });
      }
    });
  }
  document.addEventListener('keydown', function(event) {
    if (event.key === 'Escape') document.querySelectorAll('.yv-tools details[open]').forEach(function(item) { item.open = false; item.querySelector('summary').focus(); });
  });
  document.querySelectorAll('.yv-mobile-menu a').forEach(function(link) { link.addEventListener('click', function() { link.closest('details').open = false; }); });
}
if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', yrviaHeaderInit); else yrviaHeaderInit();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["yrvia-product-experience"]) return;
  try {
    
if(!customElements.get('yrvia-product-gallery'))customElements.define('yrvia-product-gallery',class extends HTMLElement{connectedCallback(){if(this.ready)return;this.ready=true;const dialog=this.querySelector('.yp-lightbox');let opener;let scrollOverflow;
this.querySelectorAll('.yp-full-image').forEach(link=>link.addEventListener('click',event=>{event.preventDefault();opener=link;const original=link.closest('.yp-media').querySelector('img');const image=document.createElement('img');image.src=link.href;image.alt=original?.alt||'';image.width=2400;image.height=2400;dialog.querySelector('.yp-lightbox-content').replaceChildren(image);scrollOverflow=document.documentElement.style.overflow;document.documentElement.style.overflow='hidden';dialog.showModal();}));
dialog.addEventListener('click',event=>{if(event.target===dialog)dialog.close();});
dialog.addEventListener('close',()=>{document.documentElement.style.overflow=scrollOverflow||'';opener?.focus({preventScroll:true});});
this.closeLightbox=()=>{if(dialog.open)dialog.close();};
const frames=[...this.querySelectorAll('[data-media-index]')];const buttons=[...this.querySelectorAll('[data-image-target]')];buttons.forEach(button=>button.addEventListener('click',()=>{const index=Number(button.dataset.imageTarget);frames.forEach((frame,i)=>{frame.hidden=i!==index;if(i!==index)frame.querySelectorAll('video').forEach(video=>video.pause());});buttons.forEach((b,i)=>b.setAttribute('aria-pressed',String(i===index)));this.querySelector('[data-image-counter]').textContent=String(index+1).padStart(2,'0');}));const shell=this.closest('.yp-shell');const add=shell.querySelector('.yp-primary-add');const sticky=shell.querySelector('[data-sticky-purchase]');this.observer=new IntersectionObserver(entries=>{sticky.hidden=entries[0].isIntersecting||add.getBoundingClientRect().top>0;},{threshold:0});this.observer.observe(add);}disconnectedCallback(){this.closeLightbox?.();this.observer?.disconnect();}});

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["yrvia-products"] && !Shopify.designMode) return;
  try {
    
function yrviaCarousels(root=document){root.querySelectorAll('.yv-products').forEach(section=>{if(section.dataset.carouselReady)return;section.dataset.carouselReady='true';const grid=section.querySelector('.yv-product-grid');section.querySelectorAll('[data-yv-direction]').forEach(button=>button.addEventListener('click',()=>{grid.scrollBy({left:Number(button.dataset.yvDirection)*grid.clientWidth,behavior:matchMedia('(prefers-reduced-motion: reduce)').matches?'instant':'smooth'});}));});}
yrviaCarousels();document.addEventListener('shopify:section:load',event=>yrviaCarousels(event.target));

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["yrvia-shade-studio"] && !Shopify.designMode) return;
  try {
    
if(!customElements.get('yrvia-shades'))customElements.define('yrvia-shades',class extends HTMLElement{connectedCallback(){if(this.ready)return;this.ready=true;this.tabs=[...this.querySelectorAll('[role="tab"]')];this.panels=[...this.querySelectorAll('[data-panel]')];this.querySelector('[role="tablist"]').hidden=false;this.select(Number(this.dataset.initial)||0,false);this.tabs.forEach((tab,index)=>{tab.addEventListener('click',()=>this.select(index,false));tab.addEventListener('keydown',e=>{let next=index;const rtl=getComputedStyle(this).direction==='rtl';if(e.key==='ArrowRight')next=(index+(rtl?-1:1)+this.tabs.length)%this.tabs.length;else if(e.key==='ArrowLeft')next=(index+(rtl?1:-1)+this.tabs.length)%this.tabs.length;else if(e.key==='Home')next=0;else if(e.key==='End')next=this.tabs.length-1;else return;e.preventDefault();this.select(next,true);});});}select(index,focus){this.tabs.forEach((t,i)=>{t.setAttribute('aria-selected',String(i===index));t.tabIndex=i===index?0:-1;});this.panels.forEach(p=>{p.hidden=Number(p.dataset.panel)!==index;p.setAttribute('role','tabpanel');p.setAttribute('aria-labelledby',this.tabs[Number(p.dataset.panel)].id);p.tabIndex=0;});if(focus)this.tabs[index].focus();}});

  } catch(e) { console.error(e); }
})();
})();
